export const SERVICES_IMAGE_URL = `${process.env.REACT_APP_IMAGE_URL}/uploads/service`;
export const PROFILE_IMAGE_URL = `${process.env.REACT_APP_IMAGE_URL}/uploads/user/profile_pic`;
export const BUSINESS_IMAGE_URL = `${process.env.REACT_APP_IMAGE_URL}/uploads/business-account`;
export const REVIEW_IMAGE_URL = `${process.env.REACT_APP_IMAGE_URL}/uploads/review_rating`;

export const days = [
  {
    id: 1,
    name: "Sunday",
  },
  {
    id: 2,
    name: "Monday",
  },
  {
    id: 3,
    name: "Tuesday",
  },
  {
    id: 4,
    name: "Wednesday",
  },
  {
    id: 5,
    name: "Thursday",
  },
  {
    id: 6,
    name: "Friday",
  },
  {
    id: 7,
    name: "Saturday",
  },
];
